import type { NotificationItem } from "@/services/types";

/**
 * In-application notifications generated from real system state — auctions due,
 * overdue auctions, collections past due, payouts awaiting approval and demands
 * crossing into overdue. Some are marked read, some unread.
 */
export const MOCK_NOTIFICATIONS: NotificationItem[] = [
  {
    id: "n-01",
    category: "auction_due",
    title: "Auction due today — Laxmi-12",
    description: "Cycle 9 auction is scheduled for today. Open the console to run it.",
    link: "/auction",
    createdAt: "2026-08-25T08:00:00.000Z",
    read: false,
  },
  {
    id: "n-02",
    category: "payout_approval",
    title: "2 payouts awaiting approval",
    description: "Vouchers PV000127 and PV000128 are ready for the organizer to approve.",
    link: "/payout",
    createdAt: "2026-08-25T07:45:00.000Z",
    read: false,
  },
  {
    id: "n-03",
    category: "demand_overdue",
    title: "8 demands crossed into overdue",
    description: "Several installments passed their due date plus the grace period.",
    link: "/collection/late-fees",
    createdAt: "2026-08-24T18:30:00.000Z",
    read: false,
  },
  {
    id: "n-04",
    category: "collection_overdue",
    title: "Shree-9 collection past due",
    description: "Cycle 6 collection is incomplete past its due date. Balance ₹38,250.",
    link: "/collection",
    createdAt: "2026-08-24T09:00:00.000Z",
    read: true,
  },
  {
    id: "n-05",
    category: "auction_overdue",
    title: "Auction overdue — Sai-8",
    description: "Cycle 1 auction has not been held past its scheduled date.",
    link: "/auction",
    createdAt: "2026-08-23T08:00:00.000Z",
    read: true,
  },
  {
    id: "n-06",
    category: "demand_overdue",
    title: "Ganesh-6 demand overdue",
    description: "Member #MEM0016 is 31+ days overdue across two cycles.",
    link: "/collection/late-fees",
    createdAt: "2026-08-22T10:00:00.000Z",
    read: true,
  },
];